export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export var API_KEY  = "";

export const setAPIKey = (apiKeyValue) => {
	API_KEY = apiKeyValue;
};

export const getAPIKey = () => {
	return API_KEY;
};